import { API, API_GET_ID } from "../../../Config";

export const GetSingleWorkout = (id) => {
  return API_GET_ID(API.SingleWorkout, id);
};
